import { isNumber, isString } from '@app/typeGuards'

import { columnSearchSchemaOptionType, TABLE_SEARCH_QUERY_PREFIX } from '@app/hooks/useTableSearch/сonstants'

import type { TableSearch } from '@app/hooks/useTableSearch/types'
import type { DecodedValueMap, QueryParamConfigMap } from 'use-query-params'
import type { TableSearchQuerySchema, TableSearchQueryKey } from './types'

const extractTableSearchKeyFromQueryKey = <ColumnsType>(
  tableSearchQueryKey: TableSearchQueryKey<ColumnsType>
): keyof ColumnsType => {
  return tableSearchQueryKey.slice(TABLE_SEARCH_QUERY_PREFIX.length) as keyof ColumnsType
}

export const queryToTableSearchAdapter = <ColumnsType>(
  query: DecodedValueMap<QueryParamConfigMap>
): TableSearch<ColumnsType> => {
  return Object.entries(query).reduce<TableSearch<ColumnsType>>((newTableSearch, [key, queryValue]) => {
    const tableSearchKey = extractTableSearchKeyFromQueryKey<ColumnsType>(key as TableSearchQueryKey<ColumnsType>)

    if (isString(queryValue)) {
      return {
        ...newTableSearch,
        [tableSearchKey]: { type: columnSearchSchemaOptionType.INPUT, value: queryValue }
      }
    }

    if (isNumber(queryValue)) {
      return {
        ...newTableSearch,
        [tableSearchKey]: { type: columnSearchSchemaOptionType.NUMERIC_INPUT, value: queryValue }
      }
    }

    if (isString(queryValue?.from) && isString(queryValue?.to)) {
      return {
        ...newTableSearch,
        [tableSearchKey]: { type: columnSearchSchemaOptionType.DATE_RANGE, value: queryValue }
      }
    }

    // TODO [MULTI_SELECT]: доработать, когда нужно будет использовать множественный select в поиске по таблице
    // if (Array.isArray(queryValue?.selected)) {
    //   return {
    //     ...newTableSearchMap,
    //     [tableSearchKey]: { type: columnSearchSchemaOptionType.MULTI_SELECT, value: queryValue }
    //   }
    // }

    if (isString(queryValue?.selected)) {
      return {
        ...newTableSearch,
        [tableSearchKey]: { type: columnSearchSchemaOptionType.SELECT, value: queryValue }
      }
    }

    if (isNumber(queryValue?.selected)) {
      return {
        ...newTableSearch,
        [tableSearchKey]: { type: columnSearchSchemaOptionType.NUMERIC_SELECT, value: queryValue }
      }
    }

    return newTableSearch
  }, {})
}

export const tableSearchToQueryAdapter = <ColumnsType>(
  tableSearch: TableSearch<ColumnsType>,
  tableSearchQuerySchema: TableSearchQuerySchema<ColumnsType>
): DecodedValueMap<QueryParamConfigMap> => {
  return Object.keys(tableSearchQuerySchema).reduce<DecodedValueMap<QueryParamConfigMap>>(
    (newTableSearchQuery, key) => {
      const tableSearchQueryKey = key as TableSearchQueryKey<ColumnsType>
      const tableSearchMapKey = extractTableSearchKeyFromQueryKey<ColumnsType>(tableSearchQueryKey)

      newTableSearchQuery[tableSearchQueryKey] = tableSearch[tableSearchMapKey]?.value

      return newTableSearchQuery
    },
    {}
  )
}
